export default __webpack_public_path__ + "static/media/room_bgm.4b39c1d5.mp3";